import { baseUrl } from '../../baseurl';
import { create } from 'zustand';
import axios from 'axios';
import Loader from '../Loader/Loader';


export const useBuyFileSubs = create((set, get) => ({
    userInfo: [],
    loader: false,
    totalPrice: 0,
    packageID: 0,
    RenewalTotalPrice: 0,
    selectedSubscription: null,
    actions: {
        setSelectedSubscription: (subscription) => set({ selectedSubscription: subscription }),
        clearSelectedSubscription: () => {
            set({ selectedSubscription: [] });
        },
        userBuyFileSubscription: async (months, description, type, isRent, isBuy, userSubscriptionDetailViewModels) => {
            // set((state) => ({ loader: true }))
            await axios.post(`${baseUrl}/UserSubscription`, {
                "months": months,
                "description": description,
                "type": type,
                "isRent": isRent,
                "isBuy": isBuy,
                "userSubscriptionDetailViewModels": userSubscriptionDetailViewModels
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    // set((state) => ({ loader: false }))

                    const packageID = res?.data?.id
                    const price = res?.data?.price;


                    set((state) => ({ totalPrice: price }))
                    set((state) => ({ packageID: packageID }))
                }).catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },


        userBuyFileSubPayRequest: async (userId, amount, paymentFor, usrSubscriptionMainCode) => {
            await axios
                .post(`${baseUrl}/Payment/PaymentRequest`, {

                    UserId: userId,
                    amount: amount, // Toman to Rial
                    paymentFor: paymentFor,

                    // CallBack: "http://localhost:3000/RegisterAd",
                    // CallBack: "https://veeu.org/RegisterAd",
                    // callBack: 'http://localhost:3000/BuyFilingSubscription',
                    // callBack: 'https://api.pelakeman.com/api/Payment/MellatReturnFromGateway',
                    callBack: 'https://api.pelakeman.com/api/Payment/zibalReturnFromGateway',
                    adsMasterCode: null,
                    usrSubscriptionMainCode: usrSubscriptionMainCode,
                }, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                    },
                })
                .then((response) => {


                    // public long trackId { get; set; }
                    // public int result { get; set; } 100 OK
                    // public string message { get; set; }

                    let paymentRequestResult = response.data;
                    // if (paymentRequestResult.result === 0) { //for mellat Bank
                    if (paymentRequestResult.result === 100) {
                        // redirect user to payment gateway
                        window.location.replace(
                            // "https://bpm.shaparak.ir/pgwchannel/startpay.mellat?RefId=" + paymentRequestResult.trackId
                            "https://gateway.zibal.ir/start/" +  paymentRequestResult.trackId
                        );
                    } else {

                        // response from bank

                        alert(paymentRequestResult?.message)
                    }
                });
        },

        // backend
        // sendVerifyToBank: async (success, userId, status, trackId, orderId) => {
        //     await axios.post(`${baseUrl}/Payment/PaymentVerify`, {
        //         success: success,
        //         userId: userId,
        //         status: status,
        //         trackId: trackId,
        //         orderId: orderId,
        //     }, {
        //         headers: {
        //             Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
        //         },
        //     })
        //         .then((response) => {
        //             console.log(response, "response at sendVerifyToBank");

        //         })
        // },

        subscriptionRenewal: async (userSubscriptionMainPackageID, userID, startDate, endDate, selectedMonths, desc2, type, isActive, isPaid, newArray) => {
            console.log("$$$$$$$$$$$$$22222222222222222222");
            console.log(newArray, "newArray");
            console.log(userID, "userID");

            set((state) => ({ loader: true }))
            await axios.patch(`${baseUrl}/UserSubscription/EditSubscription`, {
                "id": userSubscriptionMainPackageID,
                "userId": userID,
                "startDate": startDate,
                "endDate": endDate,
                "months": selectedMonths,
                "description": desc2,
                "type": type,
                "isActive": isActive,
                "isPaid": isPaid,
                "userSubscriptionDetailViewModels": newArray

            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    set((state) => ({ loader: false }))
                    set((state) => ({ RenewalTotalPrice: res?.data?.price }))
                    console.log(res, "res in SubscriptionRenewal");
                    console.log(res.data.price, "res.data.price in SubscriptionRenewal 1111111111");

                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },


    }
}))